import Swal from 'sweetalert2';
import { rejectionMessage } from './rejectionMessage';

export const getConfirmation = async (
    title: string,
    text: string,
    { cancelButtonText, confirmButtonText, showCancelButton } = {
        cancelButtonText: '',
        confirmButtonText: '',
        showCancelButton: true,
    },
) => {
    const confirmed = await Swal.fire({
        title,
        text,
        allowEscapeKey: true,
        showCancelButton,
        showConfirmButton: true,
        ...(cancelButtonText && { cancelButtonText }),
        ...(confirmButtonText && { confirmButtonText }),
    });
    return confirmed && confirmed.value;
};

export const showError = (err: unknown, title = 'Error with request') => {
    const detail = typeof err === 'string' ? err.trim() : rejectionMessage(err, '');
    return Swal.fire({
        title,
        text: detail ? `${title} ${detail}` : title,
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
    });
};
